<!--首页-->
<template>
    <div class="gray-back" style="height: 100%">
        <div class="box qz-search-wrap">
            <!--<div class="row1" v-for="(row,i) in catelist"  v-if="i<3">-->
            <!--<img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" :src="row.pic_url" />-->
            <!--</div>-->
<!--            <div class="row3">-->
<!--                <img  v-rblink="{name:'ChaSearchPerson',query:{}}"   src="../../../assets/images/bg-search-persion.png" />-->
<!--                <img  v-rblink="{name:'ChaSearchDanwei',query:{}}"   src="../../../assets/images/bg-search-danwei.png" />-->
<!--                <img  v-rblink="{name:'NewsList',query:{cate_id:71}}"   src="../../../assets/images/bg-search-download.png" />-->
<!--              <img  v-rblink="{name:'ChaSearchCaipan',query:{}}"   src="../../../assets/images/bg-search-persion.png" />-->
<!--              <img  v-rblink="{name:'ChaSearchJiaolian',query:{}}"   src="../../../assets/images/bg-search-danwei.png" />-->

<!--              <div style="clear: both"></div>-->
<!--            </div>-->

<!--            <div class="search"  v-rblink="{name:'ChaSearchAll',query:{}}">-->
<!--                <img src="../../../assets/images/icon_search.png" alt srcset />-->
<!--                <div class="placeholder">全局搜索</div>-->
<!--            </div>-->

          <van-search
              placeholder="搜索"
              shape="round"
              disabled
              v-rblink="{name:'ChaSearchAll',query:{}}"
          >
            <!--        <div slot="action" @click="onSearch(keywords)" style="padding:0 10px">搜索</div>-->
            <div class="search-content-right" slot="right-icon">
              <div class="search-button flex-center" v-rblink="{name:'ChaSearchAll',query:{}}">搜索</div>
            </div>

          </van-search>

          <div class="search-button-box flex-start">
            <div class="search-button-left">
              <img  v-rblink="{name:'NewsList',query:{cate_id:71}}"   src="../../../assets/images/cha/bg-xiazaizhongxin.png" />
            </div>
            <div class="search-button-right">
              <img  v-rblink="{name:'ChaSearchPerson',query:{}}"   src="../../../assets/images/cha/bg-gerenchaxun.png" />
              <img  v-rblink="{name:'ChaSearchCaipan',query:{}}"   src="../../../assets/images/cha/bg-caipanyuanchaxun.png" />
            </div>
            <div class="search-button-right">
              <img  v-rblink="{name:'ChaSearchDanwei',query:{}}"   src="../../../assets/images/cha/bg-danweichaxun.png" />
              <img  v-rblink="{name:'ChaSearchJiaolian',query:{}}"   src="../../../assets/images/cha/bg-jiaolianyuanchaxun.png" />
            </div> 
          </div>

        </div>
    </div>
</template>
<style scoped>
.search-button-box {
  margin: .2rem;
}

.search-button-left img {
  width: 1.86rem;
  margin-right: .2rem;
}

.search-button-right img {
  margin-bottom: .1rem;
  margin-right: .2rem;
  width: 2.42rem;
}

.qz-search-wrap .van-search {
  padding: .3rem .2rem;
}

.qz-search-wrap .van-search__content {
  border: 1px solid #FA6400;
  background: #fff;
  color: #C8C9CC;
}
.qz-search-wrap >>> .van-icon {
  color: #C8C9CC;
}

.qz-search-wrap .van-cell {
  padding: 2px 8px 2px 0;
  line-height: 30px;
}

.qz-search-wrap >>> .van-field__body input::-webkit-input-placeholder {
  color: #C8C9CC;
}

.qz-search-wrap >>> .van-field__right-icon {
  padding: 0 2px;
}

.qz-search-wrap .search-content-right {
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
}

.qz-search-wrap .search-content-right .search-button {
  background: linear-gradient(133deg, #FD9D00 0%, #FA6400 100%);
  border-radius: 50px;
  width: 52px;
  height: 30px;
}

    .box {
        background: #f8f8f8;
        padding-bottom: 50px;
        overflow: hidden;
    }
    .row1{
        /*padding: 10px;*/
        margin: 0 10px;
    }
    .row1 img{
        width: 100%;
        margin: 10px 0 0 0 ;
    }
    .row3{
        /*display: flex;*/
        /*align-items: center;*/
        /*justify-content: space-between;*/
        margin: 10px 10px;
        /*flex-wrap: wrap;*/
    }
    .row3 img{
        float: left;
        width: calc(33.33% - 10px);
        margin: 0 10px 10px 0;
    }
    .logo-ul{
        background: #fff;
        border-radius: 10px;
        height: 100px;
        margin: 0 10px;
    }
    .logo-ul div{
        text-align: center;
        float: left;
        width: calc(33.33% - 10px);
        margin: 0 0 10px 10px;
        line-height: 110px;
        height: 110px;
    }
    .logo-ul img{
        width: 100%;
        display: inline-block;
    }


    .placeholder {
        font-size: 28rpx;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(186, 186, 186, 1);
    }
    .search {
        width: 7rem;
        height: 1.0rem;
        background: rgba(239, 239, 244, 1);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin: 10px auto;
    }
    .search img {
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.2rem;
    }

</style>

<script>
    import Vue from "vue";
    import { Tab, Tabs, List, PullRefresh, Toast } from "vant";

    import NewsItem2 from "@/components/news/NewsItem2.vue";
    import NewsItem3 from "@/components/news/NewsItem3.vue";
    import NewsItem1 from "@/components/news/NewsItem1.vue";
    import NewsItem4 from "@/components/news/NewsItem4.vue";
    Vue.use(Tab)
            .use(Tabs)
            .use(PullRefresh)
            .use(List)
            .use(Toast);

    export default {
        name: "NewsList",
        components: {
            NewsItem2,
            NewsItem3,
            NewsItem1,
            NewsItem4
        },

        data: function() {
            return {
                isLoading: false,
                loading: false,
                finished: false,
                active: 0,
                activeTab: [
                ],
                catelist:[],
                list:[],
                params:{
                    cate_id:57,
                    pageNo:1,
                    pageSize:10
                },
            };
        },
        filters: {
        },
        mounted() {
            document.title = "查询";
            this.params.pageNo = 1;
            this.loading = true;
            this.finished = false;
            let that = this;

        },
        destroyed() {},
        methods: {
            fetch() {
            },
            onRefresh() {
            },
            onLoad() {
            },
        }
    };
</script>



// WEBPACK FOOTER //
// SearchIndex.vue?cfedf2c2